var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("重要訊息")]),_c('div',[_vm._v("總評分:"+_vm._s(_vm.OperationSummary))]),_c('div',[_vm._v("各店重要訊息")]),_c('paged-msg-table',{ref:"msgComp"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }